$(function(){
  // tabs
  const activeClass = 'is-active';
  const tabLinkSelector = '.js-tabpanel-link';

  window.initTabBar = function () {
    $(tabLinkSelector).on('click', function (e) {
      e.preventDefault();
      var id = $(this).attr('href');
      var $tabRoot = $(this).parents('.js-tabpanel');
      $tabRoot.find(tabLinkSelector).removeClass(activeClass);
      $(this).addClass(activeClass);
      $tabRoot.find('.js-tabpanel-block').removeClass(activeClass);
      $tabRoot.find(id).addClass(activeClass);
    });

    $('.js-tobacco-tab-select').on('change', function(){
      const id = $(this).find(":selected").attr('data-tab-id');
      const $tabRoot = $(this).parents('.js-tabpanel');
      $tabRoot.find('.js-tabpanel-block').removeClass(activeClass);
      $tabRoot.find(id).addClass(activeClass);
    });  
  }
  
  initTabBar();
})